
import { Vue, Component } from "vue-property-decorator";
import Score from "@/components/feedback/components/Score.vue";
import { UFFeedback } from "@/utils/literals/feedback";
import PieChart from "@/components/charts/PieChart.vue";
import { mapState } from "vuex";
import { FeedbackType } from "@/schemas/Enums";

@Component({
  components: { PieChart },
  computed: {
    ...mapState("session", ["session"]),
  },
})
export default class Examples extends Vue {
  // La fonction d'après sert a savoir si c'est le vieux FB ou le nouveau en moyenne, et atm on force que ce soit toujours en moyenne, pour tout le monde, même si la BDD dit le contraire
  get displayAvgFeedback(): boolean {
    // if (this.session.setting) {
    //   let settings = this.session.setting.feedback_details.find(
    //     (setting: {
    //       type: FeedbackType;
    //       display_feedback_message: boolean;
    //       display_score?: boolean;
    //       display_indiv_scores?: boolean;
    //       display_group_score?: boolean;
    //       display_avg_feedback?: boolean;
    //     }) => setting.type === FeedbackType.Performance
    //   );
    //   return settings ? settings.display_avg_feedback : false;
    // }
    // return false;
    return true;
  }
}
